





import Vue from 'vue';
import Component from 'vue-class-component';
import { Lazyload } from 'vant';
Vue.use(Lazyload)

@Component
export default class Master extends Vue{

    imgUrl = 'http://yths.zgftlm.com/static/xwyd.jpeg'

      mounted(){
        document.title="咨询预约"
    }



}

